import React from 'react';

interface IProps {
  pickedColor?: string;
  fillColor?: string;
}

const EyeDropperIcon: React.FC<IProps> = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M8.68984 10.2646C8.73708 10.3119 8.73708 10.3887 8.68984 10.4359L4.0193 15.1065C3.81725 15.3085 3.54881 15.4197 3.26317 15.4197H2.07967C1.82456 15.4197 1.58471 15.519 1.40421 15.6995C1.24383 15.8599 1.03305 15.9401 0.822516 15.9401C0.611739 15.9401 0.400961 15.8599 0.240577 15.6995C-0.0801923 15.3788 -0.0801923 14.8569 0.240577 14.5361C0.421312 14.3552 0.520644 14.1153 0.520644 13.8602V12.6772C0.520644 12.3915 0.63209 12.1231 0.833903 11.9211L5.50444 7.25052C5.55192 7.20328 5.62848 7.20328 5.67572 7.25052L8.68984 10.2646Z" 
        fill={props.pickedColor ?? "black"}
        stroke={props.fillColor ?? "black"}
        strokeWidth={0.6}
      />
      <path
        d="M15.0823 4.9976L12.1363 7.94388L12.6768 8.48439C12.8045 8.61182 12.8748 8.78166 12.8748 8.96215C12.8748 9.1424 12.8045 9.31224 12.6768 9.43967L11.5461 10.5704C11.4185 10.698 11.2489 10.7683 11.0684 10.7683C10.8879 10.7683 10.7183 10.698 10.5906 10.5704L5.36939 5.34914C5.10604 5.08579 5.10604 4.65697 5.36939 4.39362L6.50007 3.26293C6.62751 3.13549 6.79734 3.06499 6.97759 3.06499C7.15809 3.06499 7.32792 3.13549 7.45535 3.26293L7.99611 3.80368L10.9421 0.857645C11.495 0.304537 12.2303 0 13.0121 0C13.7942 0 14.5292 0.304537 15.0823 0.857645C15.6352 1.41051 15.9397 2.14557 15.9397 2.92762C15.9397 3.70968 15.6352 4.44473 15.0823 4.9976Z" 
        fill={props.fillColor ?? "black"}
      />
    </svg>
  );
}

export default EyeDropperIcon;